// Simple profanity filter for support ticket messages.
// Catches common swear words and slurs. Not exhaustive, but covers the most common cases.

const PROFANITY_LIST = [
  // Common profanity and variants
  'fuck', 'fucker', 'fucking', 'fucked', 'fucks', 'fuckface', 'fuckwit',
  'shit', 'shitty', 'shitting', 'shits', 'shithead', 'shitstain',
  'ass', 'asshole', 'dumbass', 'jackass', 'bitchass',
  'bitch', 'bitches', 'bitching', 'bitchy',
  'damn', 'goddamn', 'goddamnit',
  'dick', 'dicks', 'dickhead',
  'cock', 'cocksucker',
  'pussy', 'cum', 'cumshot',
  'bastard', 'bullshit', 'horseshit', 'dipshit',
  'motherfucker',
  'cunt', 'cunts',
  'piss', 'pissed', 'pissing',
  'prick', 'twat', 'douche', 'douchebag',
  'wanker', 'tosser', 'bellend', 'knob', 'arsehole', 'arse',

  // Slurs - racial/ethnic
  'nigger', 'nigga', 'niggas', 'spic', 'kike', 'chink', 'gook',
  'wetback', 'beaner', 'cracker', 'honky', 'gringo',
  'towelhead', 'raghead', 'redskin', 'coon',

  // Slurs - homophobic/transphobic
  'faggot', 'fag', 'fags', 'dyke', 'tranny',

  // Slurs - ableist
  'retard', 'retarded', 'retards',

  // Slurs - sexist
  'whore', 'slut',

  // Acronyms
  'stfu', 'wtf', 'gtfo', 'lmfao', 'kys', 'fml',
]

// Build a regex that matches whole words (including when preceded/followed by punctuation)
const PROFANITY_REGEX = new RegExp(
  '\\b(' + PROFANITY_LIST.join('|') + ')\\b',
  'i'
)

/**
 * Check if text contains profanity.
 * @param {string} text
 * @returns {boolean}
 */
export function containsProfanity(text) {
  if (!text) return false
  // Also check for leetspeak-style evasions of the most common words
  const normalized = text
    .replace(/@/g, 'a')
    .replace(/\$/g, 's')
    .replace(/0/g, 'o')
    .replace(/1/g, 'i')
    .replace(/3/g, 'e')
    .replace(/5/g, 's')
  return PROFANITY_REGEX.test(text) || PROFANITY_REGEX.test(normalized)
}

export const PROFANITY_WARNING =
  'Please keep your messages respectful and free of profanity. ' +
  'Although Alfred is an AI, our staff regularly review all messages sent through support. ' +
  'Please rephrase your message and try again.'
